<div class="auth-form-wrapper">
  <div class="auth-logo">
    <img src="logo-white.svg" alt="logo" />
    <p class="mt-2">Urban Infrastructure Management System</p>
  </div>

  <div class="auth-form">
    <h1 class="text-3xl mb-7 text-center">Смена пароля</h1>
    <ui-form [form]="form" [config]="formConfig" (enterPressed)="onSubmit()"> </ui-form>

    <ui-button type="primary" [block]="true" (click)="onSubmit()" [disabled]="isFormInvalid"
      >Перейти к авторизационной странице
    </ui-button>
  </div>
</div>

<img class="auth-bg" src="assets/images/bg.webp" alt="uims-bg" />
